import { fetchAuthSession } from '@aws-amplify/auth';
import { resolveSessionForType } from '../auth/resolveSession';
import config from './publishingGroupConfig.json';

export function inviteReturnPath(search) {
  const params = new URLSearchParams(search);
  const group = params.get('group');
  const invite = params.get('invite');
  if (!group || !/^[a-z0-9]+(-[a-z0-9]+)*$/.test(group) || !/^[a-f0-9]{64}$/.test(invite || '')) return null;
  return `/publishing-groups/join?${new URLSearchParams({ group, invite })}`;
}
export function authorLoginReturnPath(search) {
  const returnTo = new URLSearchParams(search).get('returnTo');
  if (returnTo === '/publishing-groups/author-membership') return returnTo;
  if (!returnTo?.startsWith('/publishing-groups/join?')) return '/authorportal/mainpage';
  return inviteReturnPath(returnTo.slice(returnTo.indexOf('?'))) || '/authorportal/mainpage';
}
export async function authorGroupRequest(path = '/author-group', { method = 'GET', body, owner, signal } = {}) {
  if (!['/author-group','/author-group-checkout','/author-billing'].includes(path)) throw Error('Invalid membership request.');
  const controller = new AbortController(), abort = () => controller.abort();
  if (signal?.aborted) abort(); signal?.addEventListener('abort',abort); let timer;
  const identity = async () => {
    let session; try { session = await resolveSessionForType('author',{restore:true,read:fetchAuthSession}); } catch { throw Object.assign(Error('Please sign in to your Author account.'),{status:401}); }
    const token = session?.data?.tokens?.idToken, sub = token?.payload?.sub;
    if (!token || !sub || (owner && owner !== sub)) throw Object.assign(Error('Your Author account changed. Sign in again before continuing.'),{status:401});
    return { token:token.toString(), sub };
  };
  const work = async () => {
    const current = await identity(); if(controller.signal.aborted)throw Error('Request cancelled.');
    const response = await fetch(`${config.apiBase}${path}`,{method,headers:{Authorization:current.token,...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:controller.signal});
    const data = await response.json();
    if ((await identity()).sub !== current.sub || controller.signal.aborted) throw Object.assign(Error('Your Author account changed. Reload membership details.'),{status:401});
    if (!response.ok) throw Object.assign(Error(typeof data?.error==='string'?data.error:'Unable to update your group membership.'),{status:response.status});
    if (!data || typeof data !== 'object' || Array.isArray(data)) throw Error('Membership response could not be confirmed. Refresh details.');
    return {...data,sessionOwner:current.sub};
  };
  try { return await Promise.race([work(),new Promise((_,reject)=>{timer=setTimeout(()=>{abort();reject(Error('Membership request timed out. Refresh details before trying again.'));},30000);})]); }
  finally { clearTimeout(timer); signal?.removeEventListener('abort',abort); }
}
export async function readGroupInvite(search, { signal } = {}) {
  const path = inviteReturnPath(search);
  if (!path) throw new Error('This invitation is not valid. Ask the group for a new link.');
  const response = await fetch(`${config.apiBase}/invite${path.slice(path.indexOf('?'))}`, { signal: signal || AbortSignal.timeout(15000) });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Unable to load this invitation.');
  if (!data || typeof data.groupName !== 'string' || !data.groupName.trim() || data.subdomain !== new URLSearchParams(search).get('group') || !Number.isFinite(data.monthlyAmount) || !Number.isFinite(data.annualAmount)) throw Error('Invitation details could not be confirmed. Ask the group for a new link.');
  return data;
}
